import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@services/translate/translate.service';

import moment from 'moment';
import * as _ from 'lodash';

@Pipe({
    name: 'translateDate',
    pure: false,
    standalone: false
})
export class TranslateDatePipe implements PipeTransform {
  constructor(private translate: TranslateService) {
  }

  transform(value, format = 'mediumDate'): any {
    if (value) {
      if (value.indexOf && value.indexOf(moment(value, format).format('dddd')) > -1) {
        value = value.replace(moment(value, format).format('dddd'), _.get(this.translate.data, 'general.days.' + moment(value, format).format('d')));
      }
      if (value.indexOf && value.indexOf(moment(value, format).format('dd')) > -1) {
        value = value.replace(moment(value, format).format('ddd'), _.get(this.translate.data, 'general.shortDays.' + moment(value, format).format('d')));
      }
      if (value.indexOf && value.indexOf(moment(value, format).format('MMMM')) > -1) {
        value = value.replace(moment(value, format).format('MMMM'), _.get(this.translate.data, 'general.months.' + moment(value, format).format('M')));
      }
      return value;
    } else {
      return value;
    }
  }
}
